import gsap from "gsap";
import barba from '@barba/core';
import { About, Home } from "./views";
import { getTime, cursor, headerLogoOnScroll, handleHeaderToggle, handleLogoHover } from './common'
import { Emitter } from "../core";

export default class Barba {
    constructor() {
        this.home = new Home();
        this.about = new About();

        getTime();
        cursor();
        handleHeaderToggle();
        //handleLogoHover();

        barba.init({
            transitions: [{
                name: 'opacity-transition',
                leave(data) {
                    return gsap.to(data.current.container, {
                        opacity: 0
                    });
                },
                enter(data) {
                    return gsap.from(data.next.container, {
                        opacity: 0
                    });
                }
            }],
            views: [
                this.home,
                this.about
            ]
        });
    }
}